// Where we have an iframe wrapped in a figure (i.e. in a RTE block)
// add a responsive class to the figure element
document.querySelectorAll('iframe').forEach(iframe => {
    if (iframe.parentElement.nodeName.toLowerCase() === 'figure') {
        const parentEl = iframe.parentElement;

        // Calculate accurate padding value to apply to parent element
        const aspectRatio = `${(iframe.clientHeight / iframe.clientWidth) * 100}%`;
        
        parentEl.classList.add('responsive-iframe');
        parentEl.style.paddingBottom = aspectRatio;
    }
});